/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'starWhite': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M509.6 134.6l106.2 222.8c8.2 17.2 23.9 29 41.9 31.6l234.5 34.2-168.4 175.1c-13 13.5-18.8 32.8-15.6 51.8l41.5 245.4-210.3-114.6c-7.8-4.3-16.7-6.5-25.5-6.5-9.1 0-18.1 2.4-26.1 6.9L279 898.7l38.5-245.9c3-19-3.1-38.2-16.3-51.5L130.6 428.4 364.7 391c18-2.9 33.6-14.9 41.5-32.2l103.4-224.2m-.3-71.4c-5.9 0-11.7 3.2-14.7 9.7L371.1 340.8c-2.4 5.1-6.9 8.6-12.2 9.5L79.1 395c-13.4 2.1-18.6 19.5-8.9 29.4l203.9 206.5c3.9 3.9 5.7 9.6 4.8 15.2l-46 293.8c-1.7 11.1 6.7 20 16.1 20 2.5 0 5.2-.6 7.7-2.1l249.6-140.3c2.4-1.4 5-2 7.7-2 2.6 0 5.2.6 7.5 1.9l251.3 136.9c2.5 1.4 5 2 7.5 2 9.5 0 18-9.1 16.1-20.2l-49.6-293.2c-.9-5.6.8-11.3 4.6-15.2l201.3-209.3c9.6-10 4.2-27.3-9.2-29.2l-280.3-40.9c-5.3-.8-9.9-4.3-12.3-9.3l-127-266.3c-3-6.3-8.8-9.5-14.6-9.5z" _fill="#1C1C1C"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/starWhite.js